import { render, staticRenderFns } from "./IcoXCircle.vue?vue&type=template&id=4ebeee8a"
import script from "./IcoXCircle.vue?vue&type=script&lang=js"
export * from "./IcoXCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports